// extracted by mini-css-extract-plugin
export default {"switch":"AppSettings_switch__yqW9D","switch__content":"AppSettings_switch__content__3fCoI"};